import { DateRange, DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'

type DateRangePickerProps = {
  selected: DateRange | null
  setSelected: (range: DateRange) => void
}

export const DateRangePicker = ({
  selected,
  setSelected,
}: DateRangePickerProps) => {
  return (
    <DayPicker
      mode="range"
      required
      selected={selected ?? undefined}
      onSelect={setSelected}
    />
  )
}
